<template>
  <div class="mt-5">
    <div v-if="isLoading" class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="system" v-for="system in project.systems" :key="system.id">
        <!-- <div class="system__refresh" v-if="system.type == 20">
          <button
            class="btn shadow-sm btn-primary round"
            @click="sync(system)"
            v-bind:disabled="system.loading"
          >
            <i class="far fa-sync" />
          </button>
        </div> -->
        <div class="system__top">
          <div class="system__top__state system-state">
            <img
              :src="
                require(`@/assets/images/system/pump/pump-${system.state}.svg`)
              "
              v-if="system.type == 5"
            />
            <img
              :src="
                require(`@/assets/images/system/machine-${system.state}.svg`)
              "
              v-if="system.type == 20"
            />

            <div class="system-state__secondary-state" v-if="system.hand">
              <img src="../assets/images/icons/hand.svg" />
            </div>
          </div>
          <div class="system__top__info">
            <div class="system__top__info__small">
              <small
                ><span class="text-muted">{{ project.name }}</span>
                <span class="text-primary">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <strong class="text-uppercase">{{
                  $filters.formatDate(system.updateDate)
                }}</strong></small
              >
            </div>
            <div class="system__top__info__name">
              {{ system.name }}
            </div>
          </div>
        </div>

        <div
          class="system__bottom"
          v-if="system.state != 40 && system.state != 50"
        >
          <ul class="list-inline mb-0">
            <li
              class="list-inline-item"
              v-for="property in system.properties"
              :key="property"
            >
              <i
                class="fal fa-tachometer-average"
                v-if="property.unit == 'Bar'"
              ></i>
              <i class="fal fa-bolt" v-if="property.unit == 'kW'"></i>
              <i class="fal fa-heart-rate" v-if="property.unit == 'Hz'"></i>
              <i
                class="fal fa-tachometer-alt"
                v-if="property.unit == 'm/h'"
              ></i>
              <i
                class="fal fa-ruler-horizontal"
                v-if="property.unit == 'm'"
              ></i>
              <i class="fal fa-ruler-vertical" v-if="property.unit == 'cm'"></i>
              <i
                class="fal fa-dewpoint"
                v-if="property.unit == 'm³/h' || property.unit == 'l/m'"
              ></i>
              <small
                >{{
                  $filters.number(property.value, 1, " ", system.updateDate)
                }}
                {{ property.unit }}</small
              >
            </li>
          </ul>
        </div>

        <router-link
          v-bind:to="'/projects/' + projectId + '/' + system.id"
        ></router-link>
      </div>
    </div>

    <!-- <pre>{{ project }}</pre> -->
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Projects from "../api/projects";
import Systems from "../api/systems";

export default {
  setup(_, { emit }) {
    const route = useRoute();
    const projectId = route.params.id;
    const project = ref({});
    const isLoading = ref(true);
    let timeout;
    let syncing = false;
    let isUnmounted = false;
    const store = useStore();
    const minInterval = 5000;
    let controller = new AbortController();

    // Debounce the sync function to prevent rapid calls
    const debouncedSync = debounce((system) => {
      if (system.loading) return;
      system.loading = true;
      Systems.sync(system.id)
        .then(() => {
          system.loading = false;
        })
        .catch(() => {
          system.loading = false;
        });
    }, 300);

    const syncProject = () => {
      if (syncing || isUnmounted) return;

      syncing = true;
      const startTime = Date.now();

      Projects.getByIdLive(projectId, { signal: controller.signal })
        .then((res) => {
          if (isUnmounted) return;

          project.value = res.data;
          syncing = false;
          const duration = Date.now() - startTime;

          if (duration >= minInterval) {
            syncProject();
          } else {
            clearTimeout(timeout);
            timeout = setTimeout(syncProject, minInterval - duration);
          }
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("[Project] Fetch aborted");
            return;
          }

          console.error("[Project] Error:", error);
          syncing = false;

          if (isUnmounted) return;

          clearTimeout(timeout);
          timeout = setTimeout(syncProject, minInterval);
        });
    };

    onMounted(() => {
      isUnmounted = false;
      controller = new AbortController();
      isLoading.value = true;

      Projects.getById(projectId, { signal: controller.signal })
        .then((res) => {
          project.value = res.data;
          isLoading.value = false;
          syncProject();
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("[Project] Fetch aborted");
            return;
          }
          console.error("[Project] Error:", error);
          isLoading.value = false;
        });

      store.commit("setShowBackButton", store.state.hasMultipleProjects);
      emit("show-back-button");
    });

    onUnmounted(() => {
      isUnmounted = true;
      clearTimeout(timeout);
      controller.abort();
    });

    return { projectId, project, sync: debouncedSync, isLoading };
  },
};

// Simple debounce function
function debounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}
</script>

<style></style>
